export default __webpack_public_path__ + "images/e5f8921b4a48376d1c9aaf06465144f0.png";